import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import {
  isProducerSelector,
  getWebinarOverMetrics,
  isPresenterAloneBeforeWebinarSelector,
} from '../../../selectors'
import {
  redirectToManagePage as redirectToManagePageAction,
  onLiveCountdownZero as onLiveCountdownZeroAction,
} from '../../../actions'
import { WebinarOverlayComponent } from '../..'
import { useSiteQuery } from '../../../../global/blocs/useSite'

const Overlay = ({
  /**
   * Connected properties
   */
  isProducer,
  isWebinarOverlayVisible,
  schedule,
  localParticipantName,
  webinarOverMetrics,
  areWebinarOverMetricsVisible,
  webinarLink,
  isPresenterAloneBeforeWebinar,

  /**
   * Connected functions
   */
  redirectToManagePage,
  onLiveCountdownZero,
}) => {
  const { data: siteData } = useSiteQuery()

  if (!isWebinarOverlayVisible && !isPresenterAloneBeforeWebinar) {
    return null
  }

  const webinarViewLink =
    webinarLink && `${siteData?.https_url ?? ''}${webinarLink}`

  return (
    <WebinarOverlayComponent
      localParticipantName={localParticipantName}
      webinarOverMetrics={webinarOverMetrics}
      isProducer={isProducer}
      areWebinarOverMetricsVisible={areWebinarOverMetricsVisible}
      webinarViewLink={webinarViewLink}
      redirectToManagePage={redirectToManagePage}
      isPresenterAloneBeforeWebinar={isPresenterAloneBeforeWebinar}
      schedule={schedule}
      onLiveCountdownZero={onLiveCountdownZero}
    />
  )
}

Overlay.propTypes = {
  /**
   * Connected properties
   */
  isProducer: PropTypes.bool,
  isWebinarOverlayVisible: PropTypes.bool,
  schedule: PropTypes.object,
  localParticipantName: PropTypes.string,
  webinarOverMetrics: PropTypes.arrayOf(PropTypes.object),
  areWebinarOverMetricsVisible: PropTypes.bool,
  webinarLink: PropTypes.string,
  isPresenterAloneBeforeWebinar: PropTypes.bool,

  /**
   * Connected functions
   */
  redirectToManagePage: PropTypes.func,
  onLiveCountdownZero: PropTypes.func,
}

const mapStateToProps = (state) => ({
  /**
   * Connected properties
   */
  isProducer: isProducerSelector(state),
  isWebinarOverlayVisible: state.webinar.isWebinarOverlayVisible,
  schedule: state.webinar.schedule,
  localParticipantName: state.webinar.localParticipantName,
  webinarOverMetrics: getWebinarOverMetrics(state),
  areWebinarOverMetricsVisible: state.webinar.areWebinarOverMetricsVisible,
  webinarLink: state.webinar.liveData.link,
  isPresenterAloneBeforeWebinar: isPresenterAloneBeforeWebinarSelector(state),
})

const mapDispatchToProps = {
  /**
   * Connected functions
   */
  redirectToManagePage: redirectToManagePageAction,
  onLiveCountdownZero: onLiveCountdownZeroAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(Overlay)
